<template>
  <img
    class="fast-track-icon"
    src="../assets/fast.svg"
    v-b-tooltip.hover
    title="This order should be prioritized"
  />
</template>

<script>
export default {}
</script>

<style scoped>
.fast-track-icon {
  width: 34px;
  vertical-align: middle;
}
</style>
